import Vue from 'vue'
import axios from "axios";
import Vuex from "vuex";
import store from '../store';

Vue.prototype.$http = axios.create({baseURL:process.env.VUE_APP_API_ENDPOINT});
Vuex.Store.prototype.$http = Vue.prototype.$http;


Vue.prototype.$http.interceptors.request.use(function (config) {
  const language=store.state.language;
  if(language){
    config.headers['X-fitt-locale']=store.state.language.locale;
  }

  if(store.state.auth.authToken!==null){
        config.headers['Authorization']='Bearer '+store.state.auth.authToken;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});


Vue.prototype.$http.interceptors.response.use(function (response) {
  return response;
}, function (error) {


  if(error.response){
    if((error.response.status===401 || error.response.data.message.indexOf('auth.invalid')>-1) && store.getters['auth/isLoggedIn']){
      store.dispatch('auth/logoutWithoutSaving',{navigate:true,clearAssessmenttoken:false});
    }else if(error.response.status===422 && error.response.data.message==='assessmenttoken.invalid'){
      store.dispatch('auth/logoutWithoutSaving',{navigate:true,clearAssessmenttoken:true});
    }
  }else{
    error.response={data:{message:error.message}};
    if(error.response.data.message.indexOf('auth.invalid')>-1 && store.getters['auth/isLoggedIn']){
      store.dispatch('auth/logoutWithoutSaving',{navigate:true,clearAssessmenttoken:false});
    }else if(error.response.data.message==='assessmenttoken.invalid'){
      store.dispatch('auth/logoutWithoutSaving',{navigate:true,clearAssessmenttoken:true});
    }
  }
  return Promise.reject(error);
});